import { render, staticRenderFns } from "./VAlert.vue?vue&type=template&id=bae26b92&scoped=true"
import script from "./VAlert.vue?vue&type=script&lang=js"
export * from "./VAlert.vue?vue&type=script&lang=js"
import style0 from "./VAlert.vue?vue&type=style&index=0&id=bae26b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae26b92",
  null
  
)

export default component.exports